const { REACT_APP_GOOGLE_ANALYTICS_ID } = process.env

interface ConfiguracaoDoAnalytics {
  googleAnalyticsId: string | undefined
}

export const analyticsConfig: ConfiguracaoDoAnalytics = {
  googleAnalyticsId: REACT_APP_GOOGLE_ANALYTICS_ID || undefined,
}
